import i18nFactory from '@yandex-int/i18n';
import * as React from 'react';

import { RouteStyledLink, StyledLinkTheme } from '../../components/StyledLink/StyledLink';
import { TextCell } from '../../components/TextCell/TextCell';
import { MarketerProductAccessCellContainer } from '../../containers/MarketerProductAccessCellContainer/MarketerProductAccessCellContainer';
import { MarketerProductRemoveCellContainer } from '../../containers/MarketerProductRemoveCellContainer/MarketerProductRemoveCellContainer';
import { UrlHelpers } from '../../service/UrlHelpers';
import { campaigns, GRID_PREFIX, LinkTarget } from '../../typings/common';
import { GridCellProps, GridColumnDecl, GridScreenUrlSearchQueryParams } from '../../typings/grid';
import { MarketerProduct } from '../../typings/marketers';

import * as keyset from './marketerProducts.i18n';

const i18n = i18nFactory(keyset);

export enum MarketerProductsColumnKeys {
    ID = 'id',
    PRODUCT_NAME = 'product-name',
    ACCESS = 'access',
    REMOVE = 'remove'
}

const WIDTH_ID = 100;
const WIDTH_PRODUCT_NAME = 250;
const WIDTH_ACCESS = 120;
const WIDTH_REMOVE = 50;

const tableCellMarketerProductId: GridColumnDecl<MarketerProduct> = {
    title: i18n('id'),
    key: MarketerProductsColumnKeys.ID,
    width: WIDTH_ID,
    isResizable: false,
    isSortable: true,
    flexGrow: 1,
    cellClass: 'marketer-products-vertically-centred',
    CellComponent: React.memo(({ rowData: item }: GridCellProps<MarketerProduct>) => <div>{item.id}</div>)
};

const tableCellMarketerProductName: GridColumnDecl<MarketerProduct> = {
    title: i18n('product-name'),
    key: MarketerProductsColumnKeys.PRODUCT_NAME,
    width: WIDTH_PRODUCT_NAME,
    isResizable: false,
    isSortable: true,
    flexGrow: 2,
    cellClass: 'marketer-products-vertically-centred',
    CellComponent: React.memo(({ rowData: item }: GridCellProps<MarketerProduct>) => {
        return (
            <TextCell>
                <RouteStyledLink
                    theme={StyledLinkTheme.blue}
                    target={LinkTarget.blank}
                    href={UrlHelpers.createNewDirectLink(
                        UrlHelpers.createNewDirectUrlPathByParams(GRID_PREFIX, campaigns),
                        {
                            [GridScreenUrlSearchQueryParams.ulogin]: item.productLogin
                        }
                    )}
                >
                    {item.productName}
                </RouteStyledLink>
            </TextCell>
        );
    })
};

const tableCellMarketerProductAccess: GridColumnDecl<MarketerProduct> = {
    title: i18n('access'),
    key: MarketerProductsColumnKeys.ACCESS,
    width: WIDTH_ACCESS,
    isResizable: false,
    isSortable: false,
    flexGrow: 2,
    cellClass: 'marketer-products-vertically-centred',
    CellComponent: React.memo(({ rowData: item }: GridCellProps<MarketerProduct>) => (
        <MarketerProductAccessCellContainer product={item} />
    ))
};

const tableCellMarketerProductRemove: GridColumnDecl<MarketerProduct> = {
    title: '',
    key: MarketerProductsColumnKeys.REMOVE,
    width: WIDTH_REMOVE,
    isResizable: false,
    isSortable: false,
    cellClass: 'marketer-products-vertically-centred',
    CellComponent: React.memo(({ rowData: item }: GridCellProps<MarketerProduct>) => (
        <MarketerProductRemoveCellContainer id={item.id} isRemoving={item.isRemoving} />
    ))
};

export function getMarketerProductsListItem(): GridColumnDecl<MarketerProduct>[] {
    return [
        tableCellMarketerProductId,
        tableCellMarketerProductName,
        tableCellMarketerProductAccess,
        tableCellMarketerProductRemove
    ];
}
